<template>
    <div class="deals-item"
         @click="_selectDeal(dealData)">
        <div class="deals-item__column">
            <div class="deals-item__column-label">
                ID сделки
            </div>
            <div class="deals-item__column-value">
                {{ dealData.leadNumber }}
            </div>
        </div>
        <div class="deals-item__column">
            <div class="deals-item__column-label">
                Телефон
            </div>
            <div class="deals-item__column-value">
                {{ dealData.clientPhoneNumber ? formatPhone(dealData.clientPhoneNumber || '—') : '—' }}
            </div>
        </div>
        <div class="deals-item__column">
            <div class="deals-item__column-label">
                Проект
            </div>
            <div class="deals-item__column-value">
                <a v-if="dealData.projectLink"
                   :href="dealData.projectLink"
                   target="_blank">
                    {{ dealData.projectName }}
                </a>
            </div>
        </div>
        <div class="deals-item__column">
            <div class="deals-item__column-label">
                Стоимость
            </div>
            <div class="deals-item__column-value">
                <template v-if="isHidePrice">
                    По&nbsp;условиям договора
                </template>
                <template v-else>
                    {{ dealData.objectCost | format }} ₽
                </template>
            </div>
        </div>
        <div class="deals-item__column">
            <div class="deals-item__column-label">
                Статус
            </div>
            <div class="deals-item__column-value">
                <DealsStatus :status-id="dealData.leadStatusId"
                             :name="dealData.newStatusName" />
            </div>
        </div>
    </div>
</template>

<script>
import DealsStatus from '@/blocks/DealsBlock/DealsStatus/DealsStatus';
import {mapActions} from 'vuex';
import Utils from '@/helpers/Utils';
import {DEALS_STATUSES} from '@/helpers/constants';

export default {
    name: 'DealsItem',

    components: {
        DealsStatus
    },

    filters: {
        format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
    },

    props: {
        dealData: Object
    },

    computed: {
        isHidePrice() {
            const status = DEALS_STATUSES.find((item) => item.id?.toLowerCase() === this.dealData?.leadStatusId?.toLowerCase());

            return Boolean(status?.hidePrice);
        }
    },

    methods: {
        ...mapActions('deals', ['selectDeal']),

        _selectDeal(deal) {
            this.selectDeal(deal);
        },

        formatPhone(phone) {
            return Utils.phoneFormat(phone);
        }
    }
};
</script>
